import { isEqual, cloneDeep } from 'lodash'
import moment from 'moment'

import history from '../../containers/History'

import {
  DATASOURCES,
  REPORTS_TABLE_COLUMN_HEADERS,
  SORT_TYPES,
  KARDIA_PRO_START_DATE,
  KARDIA_PRO_END_DATE,
  ALL_PATIENTS_OPTION,
  ALL_PHYSICIANS_OPTION,
  ALL_PRESCRIPTIONS_OPTION,
  getEsignOptions,
  getExportOptions,
  TABLE_BULK_ACTIONS,
  ROUTES,
  CLEAR_STATE,
} from '../../constants'
import {
  getDataSource,
  getMe,
  getPatients,
  getTeamReports,
  getPhysiciansAndEkgStackCount,
  getPrescriptions,
  putUpdateReports,
  postReportsEmailExport,
} from '../../store/appReducer'
import { sortReportIds, filterReportIds, downloadBillingList } from '../../containers/Tables/ReportTable/Utilities'
import { getNextSortDirection, getSelectedList } from '../../containers/Tables/Utilities'
import { handleOnNavClick as handleOnSingleReportNavClick } from '../../pages/ReportsReport/module'

// ------------------------------------
// Constants
// ------------------------------------
const PREFIX = 'Reports.'
export const UPDATE_BULK_ACTION_IS_FETCHING = `${PREFIX}UPDATE_BULK_ACTION_IS_FETCHING`
export const UPDATE_BULK_ACTION_COMPLETE = `${PREFIX}UPDATE_BULK_ACTION_COMPLETE`
export const UPDATE_BULK_ACTION_SUCCESS_MESSAGE = `${PREFIX}UPDATE_BULK_ACTION_SUCCESS_MESSAGE`
export const UPDATE_REFRESH_CLICKED = `${PREFIX}UPDATE_REFRESH_CLICKED`
export const UPDATE_SELECTED_POPOVER = `${PREFIX}UPDATE_SELECTED_POPOVER`
export const UPDATE_SELECTED_INDEX = `${PREFIX}UPDATE_SELECTED_INDEX`

export const RESET_FILTERS = `${PREFIX}RESET_FILTERS`
export const RESET_SORTS = `${PREFIX}RESET_SORTS`

export const UPDATE_SELECTED_DATES = `${PREFIX}UPDATE_SELECTED_DATES`
export const UPDATE_SELECTED_PATIENT_ID = `${PREFIX}UPDATE_SELECTED_PATIENT_ID`
export const UPDATE_SELECTED_PHYSICIAN_ID = `${PREFIX}UPDATE_SELECTED_PHYSICIAN_ID`
export const UPDATE_SELECTED_PHYSICIANS = `${PREFIX}UPDATE_SELECTED_PHYSICIANS`
export const UPDATE_SELECTED_PRESCRIPTION_ID = `${PREFIX}UPDATE_SELECTED_PRESCRIPTION_ID`
export const UPDATE_SELECTED_BILLING_CODE = `${PREFIX}UPDATE_SELECTED_BILLING_CODE`
export const UPDATE_SELECTED_ESIGNED_ID = `${PREFIX}UPDATE_SELECTED_ESIGNED_ID`
export const UPDATE_SELECTED_EXPORTED_ID = `${PREFIX}UPDATE_SELECTED_EXPORTED_ID`
export const UPDATE_SORTS = `${PREFIX}UPDATE_SORTS`
export const UPDATE_SELECTED_REPORTS = `${PREFIX}UPDATE_SELECTED_REPORTS`

export const DATA_REQUEST = `${PREFIX}DATA_REQUEST`
export const DATA_SUCCESS = `${PREFIX}DATA_SUCCESS`
export const DATA_FAILURE = `${PREFIX}DATA_FAILURE`
// ------------------------------------
// Actions
// ------------------------------------
export const updateBulkActionIsFetching = flag => ({
  type: UPDATE_BULK_ACTION_IS_FETCHING,
  payload: flag,
})
export const updateBulkActionComplete = flag => ({
  type: UPDATE_BULK_ACTION_COMPLETE,
  payload: flag,
})
export const updateBulkActionSuccessMessage = msg => ({
  type: UPDATE_BULK_ACTION_SUCCESS_MESSAGE,
  payload: msg,
})
export const updateRefreshClicked = clicked => ({
  type: UPDATE_REFRESH_CLICKED,
  payload: clicked,
})
export const updateSelectedPopover = popover => ({
  type: UPDATE_SELECTED_POPOVER,
  payload: popover,
})
export const updateSelectedIndex = index => ({
  type: UPDATE_SELECTED_INDEX,
  payload: index,
})
export const resetFilters = () => ({
  type: RESET_FILTERS,
})
export const resetSorts = () => ({
  type: RESET_SORTS,
})

export const updateSorts = (sortBy, sortDirection) => ({
  type: UPDATE_SORTS,
  payload: {
    sortBy,
    sortDirection,
  },
})
export const updateSelectedEsignedId = id => ({
  type: UPDATE_SELECTED_ESIGNED_ID,
  payload: id,
})
export const updateSelectedExportedId = id => ({
  type: UPDATE_SELECTED_EXPORTED_ID,
  payload: id,
})
export const updateSelectedPatientId = id => ({
  type: UPDATE_SELECTED_PATIENT_ID,
  payload: id,
})
export const updateSelectedPhysicianId = id => ({
  type: UPDATE_SELECTED_PHYSICIAN_ID,
  payload: id,
})
export const updateSelectedPhysicians = id => ({
  type: UPDATE_SELECTED_PHYSICIANS,
  payload: id,
})
export const updateSelectedPrescriptionId = id => ({
  type: UPDATE_SELECTED_PRESCRIPTION_ID,
  payload: id,
})
export const updateSelectedBillingCode = id => ({
  type: UPDATE_SELECTED_BILLING_CODE,
  payload: id,
})
export const updateSelectedDates = ({ startDate, endDate }) => ({
  type: UPDATE_SELECTED_DATES,
  payload: {
    startDate,
    endDate,
  },
})
export const updateSelectedReports = selected => ({
  type: UPDATE_SELECTED_REPORTS,
  payload: selected,
})
export const dataRequest = () => ({
  type: DATA_REQUEST,
})
export const dataSuccess = () => ({
  type: DATA_SUCCESS,
})
export const dataFailure = () => ({
  type: DATA_FAILURE,
})


export const getReportsData = (forceUpdate = false) => (dispatch, getState) => {
  dispatch(dataRequest())
  const meDataSource = getDataSource(getState(), DATASOURCES.ME)

  let promises

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve()
  } else {
    promises = dispatch(getMe())
  }

  return promises
    .then(() => {
      const apiCalls = []

      const me = getDataSource(getState(), DATASOURCES.ME)
      const physicians = getDataSource(getState(), DATASOURCES.PHYSICIANS)
      const ekgStackCounts = getDataSource(getState(), DATASOURCES.EKG_STACK_COUNTS)
      const prescriptions = getDataSource(getState(), DATASOURCES.PRESCRIPTIONS)

      const {
        teams,
      } = me.data

      apiCalls.push(dispatch(getPatients(teams[0].id))
        .then(() => dispatch(getTeamReports(teams[0].id))))

      if (!physicians.data || !ekgStackCounts.data || forceUpdate) {
        apiCalls.push(dispatch(getPhysiciansAndEkgStackCount(teams[0].id)))
      }

      if (!prescriptions.data || forceUpdate) {
        apiCalls.push(dispatch(getPrescriptions(teams[0].id)))
      }

      return Promise.all(apiCalls)
    })
    .then(() => dispatch(dataSuccess()))
    .catch(err => {
      console.log('getReportsData', err)
      dispatch(dataFailure())
    })
}

export const handleOnRefreshClick = () => (dispatch, getState) => {
  dispatch(updateRefreshClicked(true))
  dispatch(updateSelectedReports({}))
  return dispatch(getReportsData(true))
    .then(() => dispatch(updateRefreshClicked(false)))
}

let previousReportsIdsFiltersAndSorts
let cacheReportIds = []
export const getReportIdsFromDataSource = state => {
  const {
    [DATASOURCES.ME]: me,
    [DATASOURCES.REPORTS]: reports,
    [DATASOURCES.PATIENTS]: patients,
    [DATASOURCES.PRESCRIPTIONS]: prescriptions,
    [DATASOURCES.PHYSICIANS]: physicians,
    [DATASOURCES.BILLING_CODES]: billingCodes,
  } = state.app.dataSources
  const {
    selectedStartDate,
    selectedEndDate,
    selectedPatientId,
    selectedPhysicianId,
    selectedPhysicians,
    selectedPrescriptionId,
    selectedBillingCode,
    selectedEsignedId,
    selectedExportedId,
    sortBy,
    sortDirection,
    dataIsFetching,
  } = state.reports

  const filtersAndSorts = {
    meIsFetching: me && me.isFetching,
    reportsIsFetching: reports && reports.isFetching,
    dataIsFetching,
    selectedStartDate,
    selectedEndDate,
    selectedPatientId,
    selectedPhysicianId,
    selectedPhysicians,
    selectedPrescriptionId,
    selectedBillingCode,
    selectedEsignedId,
    selectedExportedId,
    sortBy,
    sortDirection,
  }


  let reportIds = []
  let reportByIds = {}
  let patientByIds = {}
  let prescriptionByIds = {}
  let physicianByIds = {}
  let billingCodeByIds = {}

  if (me
    && me.data
    && reports
    && reports.data
    && patients
    && patients.data
    && prescriptions
    && prescriptions.data
    && physicians
    && physicians.data
    && billingCodes
    && billingCodes.data
  ) {
    reportIds = me.data.teams[0].reports
    reportByIds = reports.data.byId
    patientByIds = patients.data.byId
    prescriptionByIds = prescriptions.data.byId
    physicianByIds = physicians.data.byId
    billingCodeByIds = billingCodes.data.byId

    if (!isEqual(previousReportsIdsFiltersAndSorts, filtersAndSorts)) {
      reportIds = filterReportIds(filtersAndSorts, reportIds, reportByIds, billingCodeByIds)
      reportIds = sortReportIds(filtersAndSorts, reportIds, reportByIds, patientByIds, prescriptionByIds, physicianByIds, billingCodeByIds)

      cacheReportIds = reportIds
    }

    previousReportsIdsFiltersAndSorts = filtersAndSorts
  }

  return cacheReportIds
}

export const handleOnSortClick = columnHeader => (dispatch, getState) => {
  const {
    sortBy,
    sortDirection,
  } = getState().reports

  if (sortBy === columnHeader) {
    const nextSortDirection = getNextSortDirection(sortDirection)
    dispatch(updateSorts(sortBy, nextSortDirection))
  } else {
    const nextSortDirection = getNextSortDirection()
    dispatch(updateSorts(columnHeader, nextSortDirection))
  }
}

export const handleOnFilterChange = (columnHeader, data) => (dispatch, getState) => {
  const {
    selectedEsignedId,
    selectedExportedId,
  } = getState().reports

  switch (columnHeader) {
  case REPORTS_TABLE_COLUMN_HEADERS.END_DATE:
    dispatch(updateSelectedDates(data))
    break
  case REPORTS_TABLE_COLUMN_HEADERS.PATIENT:
    dispatch(updateSelectedPatientId(data))
    dispatch(updateSelectedPopover(null))
    break
  case REPORTS_TABLE_COLUMN_HEADERS.PHYSICIAN:
    dispatch(updateSelectedPhysicianId(data))
    dispatch(updateSelectedPopover(null))
    break
  case REPORTS_TABLE_COLUMN_HEADERS.ORDERING_PHYSICIAN:
    dispatch(updateSelectedPhysicians(data))
    break
  case REPORTS_TABLE_COLUMN_HEADERS.PRESCRIPTION:
    dispatch(updateSelectedPrescriptionId(data))
    dispatch(updateSelectedPopover(null))
    break
  case REPORTS_TABLE_COLUMN_HEADERS.BILLING_CODE:
    dispatch(updateSelectedBillingCode(data))
    break
  case REPORTS_TABLE_COLUMN_HEADERS.ESIGNED:
    if (selectedEsignedId === data) {
      dispatch(updateSelectedEsignedId(filters.selectedEsignedId))
    } else {
      dispatch(updateSelectedEsignedId(data))
    }
    break
  case REPORTS_TABLE_COLUMN_HEADERS.EXPORTED:
    if (selectedExportedId === data) {
      dispatch(updateSelectedExportedId(filters.selectedExportedId))
    } else {
      dispatch(updateSelectedExportedId(data))
    }
    break
  default:
    break
  }
}

export const handleOnFilterButtonClick = columnHeader => (dispatch, getState) => {
  const {
    selectedPopover,
  } = getState().reports

  if (selectedPopover === columnHeader) {
    dispatch(updateSelectedPopover(null))
  } else {
    dispatch(updateSelectedPopover(columnHeader))
  }
}

export const handleOnSelectionClick = selected => (dispatch, getState) => {
  const ids = getSelectedList(selected)
  dispatch(updateSelectedReports(selected))

  if (ids.length === 0) {
    dispatch(updateBulkActionComplete(false))
  }
}

export const handleOnBulkAction = (bulkActionType, data) => (dispatch, getState) => {
  dispatch(dataRequest())

  const {
    selectedReports,
  } = getState().reports
  const {
    [DATASOURCES.REPORTS]: reports,
    [DATASOURCES.PATIENTS]: patients,
    [DATASOURCES.PHYSICIANS]: physicians,
    [DATASOURCES.BILLING_CODES]: billingCodes,
  } = getState().app.dataSources

  const selectedIds = getSelectedList(selectedReports)
  let reportIds = []
  let payload = selectedIds.map(id => {
    const report = reports.data.byId[id]

    return {
      exported: report.exportedAt !== null,
      esigned: report.esignedAt !== null,
      comments: report.comments ? report.comments : null,
      esignMemberId: report.esignMemberId ? report.esignMemberId : null,
      id,
    }
  })

  const meDataSource = getDataSource(getState(), DATASOURCES.ME)

  let successMessage
  let promises

  // ensure we have team id
  if (meDataSource.data) {
    promises = Promise.resolve()
  } else {
    promises = dispatch(getMe())
  }

  switch (bulkActionType) {
  case TABLE_BULK_ACTIONS.MARK_AS_EXPORT:
    payload = payload.map(rep => ({
      ...rep,
      // exported: false,
      // esigned: false,
      exported: true,
    }))

    reportIds = payload
      .filter(report => report.exported === true)
      .reduce((acc, report) => {
        acc.push(report.id)
        return acc
      }, [])

    successMessage = reportIds.length === 1
      ? `${reportIds.length} report has been exported. The file will be sent to your email once ready.`
      : `${reportIds.length} reports have been exported. The files will be sent to your email once ready.`

    promises = promises
      .then(() => {
        const me = getDataSource(getState(), DATASOURCES.ME)

        const {
          teams,
        } = me.data

        return Promise.all([
          dispatch(putUpdateReports(payload)),
          dispatch(postReportsEmailExport(teams[0].id, reportIds)),
        ])
      })
    break
  case TABLE_BULK_ACTIONS.DOWNLOAD_LIST:
    successMessage = 'Billing report CSV has been downloaded.'
    promises = promises
      .then(() => downloadBillingList(selectedIds, reports, patients, physicians, billingCodes))
    break
  default:
    break
  }

  dispatch(updateBulkActionIsFetching(true))
  return promises
    .then(() => {
      window.setTimeout(() => {
        dispatch(handleOnSelectionClick({}))
      }, 3000)
      dispatch(updateBulkActionIsFetching(false))
      dispatch(updateBulkActionSuccessMessage(successMessage))
      return dispatch(updateBulkActionComplete(true))
    })
    // .then(() => dispatch(updateSelectedReports({})))
    .then(() => dispatch(dataSuccess()))
    .catch(err => {
      dispatch(updateBulkActionIsFetching(false))
      dispatch(dataFailure())
    })
}

export const handleOnRowClick = ({ index, rowData }) => (dispatch, getState) => {
  dispatch(handleOnSingleReportNavClick(rowData.id))
  dispatch(updateSelectedIndex(index))
  dispatch(handleOnSelectionClick({}))
}

export const handleOnNavClick = (resetData = true, handleRouting = false) => (dispatch, getState) => {
  let promises = Promise.resolve()
  if (handleRouting) {
    promises = promises
      .then(() => history.push(ROUTES.REPORTS))
  }

  if (resetData) {
    promises = promises
      .then(() => {
        dispatch(updateBulkActionIsFetching(false))
        dispatch(updateBulkActionComplete(false))
        dispatch(updateSelectedPopover(initialState.selectedPopover))
        dispatch(updateSelectedIndex(-1))
        dispatch(resetFilters())
        dispatch(resetSorts())
      })
  }

  return promises
}

const today = KARDIA_PRO_END_DATE
const filters = Object.assign({}, {
  selectedStartDate: KARDIA_PRO_START_DATE,
  selectedEndDate: today,
  selectedPatientId: ALL_PATIENTS_OPTION.id,
  selectedPhysicianId: ALL_PHYSICIANS_OPTION.id,
  selectedPrescriptionId: ALL_PRESCRIPTIONS_OPTION.id,
  selectedBillingCode: [],
  selectedEsignedId: getEsignOptions()[0].id,
  selectedExportedId: getExportOptions()[0].id,
  selectedReports: {},
  selectedPhysicians: [],
})
const sorts = Object.assign({}, {
  sortBy: REPORTS_TABLE_COLUMN_HEADERS.END_DATE,
  sortDirection: SORT_TYPES.DESC,
})
const initialState = {
  ...cloneDeep(filters),
  ...cloneDeep(sorts),
  bulkActionIsFetching: false,
  bulkActionComplete: false,
  bulkActionSuccessMessage: null,
  refreshClicked: false,
  selectedIndex: -1,
  selectedPopover: null,
  dataIsFetching: false,
  dataLastUpdated: null,
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_BULK_ACTION_IS_FETCHING]: (state, action) => ({
    ...state, bulkActionIsFetching: action.payload,
  }),
  [UPDATE_BULK_ACTION_COMPLETE]: (state, action) => ({
    ...state, bulkActionComplete: action.payload,
  }),
  [UPDATE_BULK_ACTION_SUCCESS_MESSAGE]: (state, action) => ({
    ...state, bulkActionSuccessMessage: action.payload,
  }),
  [UPDATE_REFRESH_CLICKED]: (state, action) => ({
    ...state, refreshClicked: action.payload,
  }),
  [UPDATE_SELECTED_POPOVER]: (state, action) => ({
    ...state, selectedPopover: action.payload,
  }),
  [UPDATE_SELECTED_INDEX]: (state, action) => ({
    ...state, selectedIndex: action.payload,
  }),

  [RESET_FILTERS]: (state, action) => ({
    ...state, ...filters,
  }),
  [RESET_SORTS]: (state, action) => ({
    ...state, ...sorts,
  }),

  [UPDATE_SELECTED_ESIGNED_ID]: (state, action) => ({
    ...state, selectedEsignedId: action.payload,
  }),
  [UPDATE_SELECTED_EXPORTED_ID]: (state, action) => ({
    ...state, selectedExportedId: action.payload,
  }),
  [UPDATE_SELECTED_PATIENT_ID]: (state, action) => ({
    ...state, selectedPatientId: action.payload,
  }),
  [UPDATE_SELECTED_PHYSICIAN_ID]: (state, action) => ({
    ...state, selectedPhysicianId: action.payload,
  }),
  [UPDATE_SELECTED_PHYSICIANS]: (state, action) => ({
    ...state, selectedPhysicians: action.payload,
  }),
  [UPDATE_SELECTED_PRESCRIPTION_ID]: (state, action) => ({
    ...state, selectedPrescriptionId: action.payload,
  }),
  [UPDATE_SELECTED_BILLING_CODE]: (state, action) => ({
    ...state, selectedBillingCode: action.payload,
  }),
  [UPDATE_SELECTED_DATES]: (state, action) => ({
    ...state, selectedStartDate: action.payload.startDate, selectedEndDate: action.payload.endDate,
  }),
  [UPDATE_SORTS]: (state, action) => ({
    ...state, sortBy: action.payload.sortBy, sortDirection: action.payload.sortDirection,
  }),
  [UPDATE_SELECTED_REPORTS]: (state, action) => ({
    ...state, selectedReports: action.payload,
  }),
  [DATA_REQUEST]: (state, action) => ({
    ...state, dataIsFetching: true,
  }),
  [DATA_SUCCESS]: (state, action) => ({
    ...state, dataIsFetching: false, dataLastUpdated: new Date(),
  }),
  [DATA_FAILURE]: (state, action) => ({
    ...state, dataIsFetching: false, dataLastUpdated: new Date(),
  }),
  [CLEAR_STATE]: (state, action) => ({ ...initialState }),
}

// ------------------------------------
// Reducer
// ------------------------------------
export default function reportsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/legacy/pages/Reports/module.js